"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ALPHA_BaseCarousel = void 0;
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var base_carousel_module_scss_1 = __importDefault(require("./base-carousel.module.scss"));
var CarouselNavigationButtons_1 = require("./carousel-navigation-buttons/CarouselNavigationButtons");
var CarouselList_1 = require("./carousel-list/CarouselList");
var ALPHA_BaseCarousel = function (_a) {
    var _b;
    var children = _a.children, _c = _a.showVisibleScrollbar, showVisibleScrollbar = _c === void 0 ? false : _c, numberOfItemsToShow = _a.numberOfItemsToShow, ariaLabel = _a.ariaLabel, heading = _a.heading, id = _a.id;
    // Items received to show in the carousel.
    var items = react_1.default.Children.toArray(children);
    // Number of pages to show those items on.
    var numberOfPages = Math.ceil(items.length / numberOfItemsToShow);
    // Reference for the Carousels scroller/wrap element.
    var ulContainerElement = (0, react_1.useRef)(null);
    // Tracking which page is currently in view.
    var _d = (0, react_1.useState)(0), currentPage = _d[0], setCurrentPage = _d[1];
    // Show navigation controls.
    var showNavigationConrols = items.length > numberOfItemsToShow ? true : false;
    (0, react_1.useEffect)(function () {
        var carouselScroller = ulContainerElement.current;
        var observer = new IntersectionObserver(function (observations) {
            for (var _i = 0, observations_1 = observations; _i < observations_1.length; _i++) {
                var observation = observations_1[_i];
                observation.target.classList.toggle('--in-view', observation.isIntersecting);
                if (observation.isIntersecting) {
                    var currentPageId = +observation.target.getAttribute('data-pageid');
                    if (currentPageId === numberOfPages - 1) {
                        var previousPage = observation.target.previousElementSibling;
                        previousPage.classList.remove('--in-view');
                    }
                    setCurrentPage(+observation.target.getAttribute('data-pageId'));
                }
            }
        }, {
            root: carouselScroller,
            threshold: 0.8,
            rootMargin: "0% -2% 0% -2%",
        });
        Array.from(carouselScroller.children).forEach(function (item) {
            observer.observe(item);
        });
        return function () {
            observer.unobserve(carouselScroller);
        };
    }, [numberOfPages, currentPage]);
    //* Accessibility implementation commented out for now,
    //* look at revising work on this following testing with Fable.
    // This is for accessibility and ensures the carousel next/prev buttons are updated
    // as required
    // const handleKeyUp = (pageNumber: number) => {
    //   updateCurrentIndex(pageNumber);
    // };
    // const updateCurrentIndex = (pageNumber: number): void => {
    //   if (isValidPageNumber(pageNumber) && pageNumber !== currentIdx) {
    //     setCurrentIdx(pageNumber);
    //   }
    // };
    // const isValidPageNumber = (pageNumber: number): boolean => {
    //   return !isNaN(pageNumber);
    // };
    var goToPage = function (scrollport, element) {
        var position = Math.abs(scrollport.offsetLeft - element.offsetLeft);
        scrollport.scrollTo({ left: position, behavior: 'smooth' });
    };
    var goNext = function () {
        var current = ulContainerElement.current.querySelectorAll('.--in-view');
        var next = current[0].nextElementSibling;
        if (next) {
            goToPage(ulContainerElement.current, next);
        }
    };
    var goPrevious = function () {
        var current = ulContainerElement.current.querySelectorAll('.--in-view');
        var next = current[0].previousElementSibling;
        if (next) {
            goToPage(ulContainerElement.current, next);
        }
    };
    var goToNextDirection = function (dir) {
        if (dir === 'right') {
            goNext();
        }
        else if (dir === 'left') {
            goPrevious();
        }
    };
    return (react_1.default.createElement("section", { "aria-label": ariaLabel, "aria-roledescription": "Carousel" },
        react_1.default.createElement("div", { className: (0, classnames_1.default)(base_carousel_module_scss_1.default['carousel']) },
            react_1.default.createElement("div", { className: (0, classnames_1.default)(base_carousel_module_scss_1.default['carousel__header-container'], (_b = {},
                    _b[base_carousel_module_scss_1.default['carousel__heading']] = heading,
                    _b)) },
                heading && react_1.default.createElement("h2", { "data-testid": "carousel-heading" }, heading),
                showNavigationConrols && (react_1.default.createElement(CarouselNavigationButtons_1.ALPHA_CarouselNavigationButtons, { goToNextDirection: goToNextDirection, currentPage: currentPage, numberOfPages: numberOfPages }))),
            react_1.default.createElement(CarouselList_1.CarouselList, { id: id, showVisibleScrollbar: showVisibleScrollbar, ulContainerElementRef: ulContainerElement, 
                // handleKeyUp={handleKeyUp}
                items: items }))));
};
exports.ALPHA_BaseCarousel = ALPHA_BaseCarousel;
//# sourceMappingURL=BaseCarousel.js.map